<template>
  <div class="titleTemp1">
    <div class="title">{{data.title}}</div>
    <div class="subtitle">{{data.subtitle}}</div>
  </div>
</template>

<script>
export default {
  name: "titleTemp1",
  props: ["data"],
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.titleTemp1 {
  > .title {
    color: #3a3a3a;
    font-size: 38px;
    line-height: 53px;
    text-align: center;
  }
  > .subtitle {
    color: #999999;
    font-size: 28px;
    line-height: 40px;
    text-align: center;
    margin-bottom: 49px;
  }
}
</style>



// WEBPACK FOOTER //
// src/templates/titleTemp1.vue